import { gql } from 'apollo-boost'

import useMutation from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: ParcelHistoryUpdateInput!
  ) {
    updateOneParcelHistory(
      where: { id: $id }
      data: $data
    ) {
      id
      year
      culture {
        id
        name
      }
    }
  }
`

export default () => (
  useMutation(MUTATION)
)
